import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display',
            'page-title',
            'section-title',
            'card-title',
            'body-lg',
            'body',
            'body-sm',
            'body-comfort',
            'caption',
            'eyebrow',
            'metric',
          ],
        },
      ],
      rounded: [{ rounded: ['control', 'control-comfort'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
